import { render, staticRenderFns } from "./appletlist.vue?vue&type=template&id=54102bd0&scoped=true&"
import script from "./appletlist.vue?vue&type=script&lang=js&"
export * from "./appletlist.vue?vue&type=script&lang=js&"
import style0 from "./appletlist.vue?vue&type=style&index=0&id=54102bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54102bd0",
  null
  
)

export default component.exports